export const BuyProcessStepsTestIds = {
  SubmissionInformation: 'submission-information-step-0',
  ClientInfo: 'client-info-step-1',
  CompanyDetails: 'company-details-step-2',
};
